import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31830b64&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=31830b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31830b64",
  null
  
)

export default component.exports